import moment from 'moment-timezone';
import {
	ANALYTICS_TIME_ZONE_PARAM_NAMES,
	formatDateForParam,
	myTimeZone,
	timeZoneOfDate,
} from './DataFormatterUtils';

export enum ANALYTICS_UPPER_BOUND {
	INCLUSIVE = 'inclusive',
	EXCLUSIVE = 'exclusive',
}

const SECONDARY_DATE_PAIRS = [
	{
		startName: 'workCreatedAtStartDate',
		endName: 'workCreatedAtEndDate',
		timeZoneName: 'workCreatedAtTimeZone',
	},
	{
		startName: 'workCompletedAtStartDate',
		endName: 'workCompletedAtEndDate',
		timeZoneName: 'workCompletedAtTimeZone',
	},
];

const toValidMoment = (value) => {
	if (!value) return undefined;
	const parsed = moment.isMoment(value) ? value : moment(value);
	return parsed.isValid() ? parsed : undefined;
};

const resolveTimeZone = (explicitTimeZone, value) =>
	explicitTimeZone || timeZoneOfDate(value) || myTimeZone();

const startOfDayInZone = (parsed, timeZone) => parsed.clone().tz(timeZone, true).startOf('day');

export const formatAnalyticsStartDate = (value, timeZone?) => {
	const parsed = toValidMoment(value);
	return parsed
		? formatDateForParam(startOfDayInZone(parsed, resolveTimeZone(timeZone, value)))
		: undefined;
};

export const formatAnalyticsEndDate = (value, upperBound, timeZone?) => {
	const parsed = toValidMoment(value);
	if (!parsed) return undefined;
	const startOfEndDay = startOfDayInZone(parsed, resolveTimeZone(timeZone, value));
	return upperBound === ANALYTICS_UPPER_BOUND.EXCLUSIVE
		? formatDateForParam(startOfEndDay.add(1, 'day'))
		: formatDateForParam(startOfEndDay.endOf('day'));
};

export const buildAnalyticsDateParams = (params, upperBound) => {
	const next = { ...(params || {}) };

	const primaryTimeZone = resolveTimeZone(next.timeZone, next.startDate);
	const startDate = formatAnalyticsStartDate(next.startDate, primaryTimeZone);
	const endDate = formatAnalyticsEndDate(next.endDate, upperBound, primaryTimeZone);

	if (startDate) {
		next.startDate = startDate;
	} else {
		delete next.startDate;
	}
	if (endDate) {
		next.endDate = endDate;
	} else {
		delete next.endDate;
	}

	SECONDARY_DATE_PAIRS.forEach(({ startName, endName, timeZoneName }) => {
		const pairTimeZone = resolveTimeZone(next[timeZoneName], next[startName]);
		const pairStartDate = formatAnalyticsStartDate(next[startName], pairTimeZone);
		const pairEndDate = formatAnalyticsEndDate(next[endName], upperBound, pairTimeZone);
		if (pairStartDate) {
			next[startName] = pairStartDate;
		} else {
			delete next[startName];
		}
		if (pairEndDate) {
			next[endName] = pairEndDate;
		} else {
			delete next[endName];
		}
	});

	ANALYTICS_TIME_ZONE_PARAM_NAMES.forEach((timeZoneName) => {
		delete next[timeZoneName];
	});

	return next;
};
